module.exports = __webpack_public_path__ + "7ab56da546e8f5de710f6f623c87c35c.webp";